var React = require('react');

function Vietnam (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M44 0H4C1.79086 0 0 1.79086 0 4V28C0 30.2091 1.79086 32 4 32H44C46.2091 32 48 30.2091 48 28V4C48 1.79086 46.2091 0 44 0Z","fill":"#DA251D","key":0}),React.createElement("path",{"d":"M24 6.39999L18.352 23.76L33.136 13.04H14.864L29.648 23.76L24 6.39999Z","fill":"#FFFF00","key":1})]);
}

Vietnam.defaultProps = {"width":"48","height":"32","viewBox":"0 0 48 32","fill":"none"};

module.exports = Vietnam;

Vietnam.default = Vietnam;
